import { jsx as _jsx } from "react/jsx-runtime";
import { getButtonClasses } from '#pplx/frontend/aether/components/Button/classes.js';
import { Button } from '#pplx/frontend/aether/components/Button/index.js';
import { Icon } from '#pplx/frontend/aether/components/Icon/index.js';
import { Tooltip } from '#pplx/frontend/aether/components/Tooltip/index.js';
import { ButtonPrimitive } from '#pplx/frontend/aether/primitives/ButtonPrimitive/index.js';
import { sidebarMenuItemClickedEvent } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import classNames from 'classnames';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
const planButtonMessages = defineMessages({
    upgrade: {
        defaultMessage: 'Upgrade plan',
        description: 'Button text to upgrade to the next tier',
        id: 'fc17888678',
    },
    view: {
        defaultMessage: 'View plans',
        description: 'Button text for logged-out users to view subscription plans',
        id: '136fb43dd8',
    },
});
const SidebarPlanButton = ({ icon, isExpanded, message, onClick, tabType, testId, }) => {
    const { track } = useInstrumentation();
    const { $t } = useIntl();
    const tooltipContent = $t(message);
    const handleClick = () => {
        track(sidebarMenuItemClickedEvent({
            name: 'sidebar menu item clicked',
            data: {
                tabType,
                location: 'sidebar',
            },
        }));
        onClick();
    };
    if (!isExpanded) {
        return (_jsx("div", { className: "relative inline-flex", children: _jsx(Tooltip, { content: tooltipContent, side: "right", offsetPx: 18, children: _jsx(ButtonPrimitive, { "aria-label": tooltipContent, "data-testid": testId, className: classNames(getButtonClasses({
                        variant: 'text',
                        size: 'default',
                        rounded: true,
                        iconOnly: true,
                    }), 'shrink-0 !size-8'), onClick: handleClick, children: _jsx(Icon, { icon: icon, size: "default" }) }) }) }));
    }
    return (_jsx("div", { className: "w-full overflow-hidden", children: _jsx("div", { className: "flex w-full justify-center my-1", children: _jsx("div", { className: "relative inline-flex", children: _jsx(Button, { variant: "secondary", size: "tiny", pill: true, onClick: handleClick, leadingAccessory: icon, "data-testid": testId, children: _jsx(FormattedMessage, { ...message }) }) }) }) }));
};
export const SidebarUpgradeButton = ({ onUpgradeClick, isExpanded, }) => (_jsx(SidebarPlanButton, { icon: $icon('circle-arrow-up'), isExpanded: isExpanded, message: planButtonMessages.upgrade, onClick: onUpgradeClick, tabType: "upgrade", testId: "sidebar-upgrade-button" }));
export const SidebarViewPlansButton = ({ onViewPlansClick, isExpanded, }) => (_jsx(SidebarPlanButton, { icon: $icon('layout-columns'), isExpanded: isExpanded, message: planButtonMessages.view, onClick: onViewPlansClick, tabType: "view plans" }));
//# sourceMappingURL=SidebarUpgradeButton.js.map